import React from "react";
import { FormattedMessage, injectIntl } from "react-intl";
import useJourneyContext from "../../hooks/useJourneyContext";
import rand from "../../utils/rand";
import LoadingSkeleton from "../LoadingSkeleton";
const LivePlatformStatus = ({
  callingPoint,
  type = "departure",
  intl
}) => {
  var _a, _b, _c;
  const { isInitializing } = useJourneyContext();
  if (isInitializing) {
    return /* @__PURE__ */ React.createElement(LoadingSkeleton, {
      style: { height: "14px", width: rand(["100px", "150px"]) }
    });
  }
  const data = type === "departure" ? callingPoint == null ? void 0 : callingPoint.departure : callingPoint == null ? void 0 : callingPoint.arrival;
  if (data) {
    const scheduledPlatform = (_a = data.schedule) == null ? void 0 : _a.platform;
    const realTimePlatform = (_b = data.realTime) == null ? void 0 : _b.platform;
    const status = (_c = data.realTime) == null ? void 0 : _c.status;
    if (status === "CANCELLED") {
      return /* @__PURE__ */ React.createElement(FormattedMessage, {
        id: "liveTracker.platformStatus.cancelled"
      });
    }
    if (!scheduledPlatform && !realTimePlatform) {
      return null;
    }
    const messageId = realTimePlatform ? "liveTracker.platformStatus.realTimePlatform" : "liveTracker.platformStatus.scheduledPlatform";
    const platform = realTimePlatform || scheduledPlatform;
    const platformAriaLabel = intl.formatMessage({ id: `${messageId}.accessibility` }, { platform });
    return /* @__PURE__ */ React.createElement("span", {
      "aria-label": platformAriaLabel
    }, intl.formatMessage({
      id: messageId
    }, { platform }));
  }
  return null;
};
var LivePlatformStatus_default = injectIntl(LivePlatformStatus);
export {
  LivePlatformStatus_default as default
};
